import type { MatchingSib } from './types'

export const NO_REGION_LABEL = 'Ohne Region'

export interface RegionGroup {
  region: string
  sibs: MatchingSib[]
}

/**
 * Group the matching SIBs by their sales region for the "Region" tab (SIB-920).
 *
 * The input is the exact matching result, so both tabs always show the same SIBs;
 * this only changes the presentation. Regions are sorted alphabetically (German
 * collation); SIBs without a region go into a trailing "Ohne Region" group. The
 * order of SIBs inside a group is preserved from the matching result, which is
 * already sorted by traffic light status.
 */
export function groupSibsByRegion(sibs: MatchingSib[]): RegionGroup[] {
  const byRegion = new Map<string, MatchingSib[]>()
  const withoutRegion: MatchingSib[] = []

  for (const sib of sibs) {
    const region = sib.salesRegion?.trim()
    if (!region) {
      withoutRegion.push(sib)
      continue
    }
    byRegion.set(region, [...(byRegion.get(region) ?? []), sib])
  }

  const groups: RegionGroup[] = Array.from(byRegion.entries())
    .sort(([a], [b]) => a.localeCompare(b, 'de'))
    .map(([region, regionSibs]) => ({ region, sibs: regionSibs }))

  if (withoutRegion.length > 0) {
    groups.push({ region: NO_REGION_LABEL, sibs: withoutRegion })
  }

  return groups
}
